module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3o8jzUJwtagQaQ6GMKa2O4-66f5f1015e40ad84f5ad8654fc584165.jpg";